import { render } from "./CreateRoutes.vue?vue&type=template&id=48d8b4aa&scoped=true"
import script from "./CreateRoutes.vue?vue&type=script&lang=js"
export * from "./CreateRoutes.vue?vue&type=script&lang=js"

import "./CreateRoutes.vue?vue&type=style&index=0&id=48d8b4aa&lang=scss&scoped=true"
import "./CreateRoutes.vue?vue&type=style&index=1&id=48d8b4aa&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d8b4aa"]])

export default __exports__